import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import classes from './pushElements.module.scss'
import { useDispatch } from 'react-redux'
import { pushElements, pushToRegistrationForm } from '../../store/reducers/RegistrationReducer/Form'
import { DirectionService } from "../../api/directionService";
import { toast } from "react-toastify";

const PushElements = ({ onChange, id, title }) => {
    const dispatch = useDispatch()
    const [addField, setAddfiled] = useState({ id: '', obj: '' })
    const { register, handleSubmit } = useForm()

    const onSubmit = async (data) => {
        const fieldValue = data?.[id]

        if (id === 'departmentId') {
            const res = await DirectionService.setDepartment({ name: fieldValue })
            if (res?.data) {
                dispatch(pushToRegistrationForm({ ...res.data, formName: id }))
                onChange(false)
                toast.success('Відділення створено')
            }
        } else if (id === 'hospitalId') {
            const res = await DirectionService.setHospital({ name: fieldValue, registrationType: "BASIC" })
            if (res?.data) {
                dispatch(pushToRegistrationForm({ ...res.data, formName: id }))
                onChange(false)
                toast.success('Заклад створено')
            }
        } else if (id === 'antibodies') {
            const res = await DirectionService.setAntibodies({ name: fieldValue })
            if (res?.data) {
                dispatch(pushToRegistrationForm({ ...res.data, formName: id }))
                onChange(false)
                toast.success('Антитіло додано')
            }
        } else {
            setAddfiled({ id: id, obj: fieldValue })
        }
    }

    useEffect(() => {
        if (addField.obj !== '') {
            dispatch(pushElements({ credential: addField }))
            onChange(false)
        }
    }, [addField])

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains(classes.backdrop)) {
            onChange(false)
        }
    }

    return (
        <div className={classes.backdrop} onClick={handleBackdropClick}>
            <div className={classes.container}>
                <button onClick={() => onChange(false)} className={classes.closeButton}>X</button>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                    <label className={classes.form__label}>{title}</label>
                    <input className={classes.form__input} {...register(id)} />
                    <button className={classes.form__button} type='submit'>
                        Додати
                    </button>
                </form>
            </div>
        </div>
    )
}

export default PushElements
